/**
 * Конфигурация URL из переменных окружения
 * VITE_APP_MODE=dev → relative URLs (Vite proxy проксирует /api и /ws)
 * prod → VITE_API_DOMAIN
 */
const isDev = import.meta.env.VITE_APP_MODE === "dev";
const API_DOMAIN =
  (isDev ? import.meta.env.VITE_API_DEV_DOMAIN : import.meta.env.VITE_API_DOMAIN) ||
  import.meta.env.VITE_API_DOMAIN ||
  "api.phodo.ru";

// dev: пустая строка = same origin, Vite proxy проксирует /api и /ws
// prod: полный URL
export const BASE_URL = isDev ? "" : `https://${API_DOMAIN}`;
export const BASE_WS_URL = isDev ? "" : `wss://${API_DOMAIN}`;
